import { OrderPayables } from "../OrderPayables";
import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesMultiProfile extends Layout {
    layoutOrderPayables: OrderPayables;
    sourceOrderPayablesCache: DataSource;
    sourceOrderPayablesProfile: DataSource;
    sourceVoidedPayablesOrderPayables: DataSource;
    tabProfile: Tab;
    tabsetOrderPayablesProfiles: Tabset;
}
